/* eslint-disable no-unused-vars */
import React from 'react';
import { Redirect, Route, RouteProps, Router, Switch } from 'react-router-dom';
import Home from '../components/dashboard';
import InvestorLogin from '../components/auth';
import { history } from '../store';
import ProtectedRoute from './ProtectedRoute';
import RedirectRoute from './RedirectRoute';
import QuickLinkRoutes from '../components/quick-links';
import SignUpQuestionnaire from '../components/auth/SignUpQuestionnaire';
import ResetDevices from '../components/auth/ResetDevices';
import Stack from '../components/Stack';
import compareVersions from 'compare-versions';
import { connect } from 'react-redux';
import { hardPushRequired } from '../redux-store/actions/mobile';
import { Button, Dialog } from '@material-ui/core';
import en from '../lang/en-us';
import { isMobile } from '../components/quick-links/faq';
import { isMobileDevice } from '../utils/constants';
import { SubmitButton } from '../lib/Button';
import ResetQuestionnaire from '../components/auth/ResetQuestionnaire';
import { getPageTitle } from '../lib/pageHeading';

export interface AuthType extends RouteProps {
    token: string | undefined;
    component: React.ComponentType<any>;
    isLoggedOut?: boolean | undefined;
    isLoggedIn?: boolean;
    userId?: string;
}

const { common } = en;

function AppRoutes(_props: any) {
    const [forceUpdate, setForceUpdate] = React.useState<'YES' | 'NO' | 'MAYBE'>('NO');

    React.useEffect(() => {
        document.title = getPageTitle(history.location.pathname);
        const unlisten = history.listen((location: any) => {
            document.title = getPageTitle(location.pathname);
        });
        return () => {
            unlisten();
        };
    }, []);

    React.useEffect(() => {
        const checkUpdate = async ({
            currentVersionAndroid,
            currentVersionIOS,
            forceUpdate,
        }: {
            currentVersionAndroid: string;
            currentVersionIOS: string;
            forceUpdate: 'YES' | 'NO';
        }) => {
            const _window: any = window;
            const { platform } = _window.device || {};
            const currentAppVersion = await _window.cordova.getAppVersion.getVersionNumber();
            const latestVersion =
                platform === 'Android' ? currentVersionAndroid : currentVersionIOS;
            // alert(currentAppVersion+latestVersion+"");
            let versionComp: number = compareVersions(latestVersion, currentAppVersion);
            if (versionComp === 1) {
                if (forceUpdate === 'YES') {
                    setForceUpdate('YES');
                    return;
                }
                setForceUpdate('MAYBE');
            }
        };
        async function onForceUpdate() {
            let res = await _props.hardPushRequired({});
            checkUpdate(res.body);
        }

        function loadIntialOverides() {
            let interval: any;
            const _window: any = window;

            var body = document.getElementsByTagName('html')[0];
            body.style.userSelect = 'none';
            body.style.webkitUserSelect = 'none';

            window.alert = function (message, timeOut = 2 * 1000) {
                if (interval) {
                    clearTimeout(interval);
                }
                var node: any = document.getElementById('snackbar');
                node.innerHTML = message;
                node.className = 'show';
                interval = setTimeout(function () {
                    node.className = node.className.replace('show', '');
                }, timeOut);
            };
            window.open = _window.cordova.InAppBrowser.open;
        }

        const onDeviceReady = () => {
            console.log(window);

            if (isMobileDevice()) {
                onForceUpdate();
                loadIntialOverides();
            }
        };
        document.addEventListener('deviceready', onDeviceReady, false);
        return () => {
            document.removeEventListener('deviceready', onDeviceReady);
        };
    }, []);

    const onDownload = async () => {
        const _window: any = window;
        const { platform } = _window.device;
        const _package: string = await _window.cordova.getAppVersion.getPackageName();
        // window.open(`market://details?id=${_package}`,"_system");
        if (platform === 'Android') {
            window.open('market://details?id=com.mfcentral.app', '_system');
        } else {
            window.open('itms-apps://itunes.apple.com/app/mfcentral/id16008590142', '_self');
        }
    };
    const onSkip = () => {
        setForceUpdate('NO');
    };

    return (
        <div>
            <Router history={history}>
                <Switch>
                    <Route
                        exact
                        path="/"
                        render={(props: any) => (
                            <Redirect {...props} to="/investor" from={props.location.pathname} />
                        )}
                    ></Route>
                    <ProtectedRoute path="/portal" component={Home} />
                    <RedirectRoute path="/investor" component={InvestorLogin} />
                    <RedirectRoute path="/links" component={QuickLinkRoutes} />
                    <RedirectRoute path="/signup-questionnaire" component={SignUpQuestionnaire} />
                    <RedirectRoute path="/reset-questionnaire" component={ResetQuestionnaire} />
                    <RedirectRoute path="/stack" component={Stack} />
                </Switch>
            </Router>
            <Dialog maxWidth={'sm'} open={forceUpdate !== 'NO'} aria-labelledby="update-app-modal">
                <div className="update-app-modal">
                    <p>{common.forceUpdate.forceInfo}</p>
                    <div className="btns">
                        <SubmitButton label="Download" type="submit" onClick={onDownload} />
                        {forceUpdate === 'MAYBE' ? (
                            <Button className="customBtn cancelBtn" onClick={onSkip}>
                                SKIP
                            </Button>
                        ) : null}
                    </div>
                </div>
            </Dialog>
            {/* <Dialog maxWidth={'sm'} open={forceUpdate !== 'NO'} aria-labelledby="enable-fingerprint-modal">
                <div className="enable-fingerprint-modal">

                    <p onClick = {onDownload}>DOWNLOAD</p>
                    {forceUpdate === 'MAYBE' ? <p onClick ={onSkip}>SKIP</p> : null}
                </div>
            </Dialog> */}
        </div>
    );
}

export default connect(null, { hardPushRequired })(AppRoutes);
